// TopBar — current user + sign-out. Phase 1c keeps it simple; breadcrumbs
// and theme toggle land in a later commit.
import { useState } from "react";
import { LogOut, ChevronDown } from "lucide-react";
import { useAuth } from "../../auth/useAuth";

function Avatar({ name }: { name: string }) {
  const initials =
    name
      .split(/\s+/)
      .map((p) => p[0]?.toUpperCase() ?? "")
      .join("")
      .slice(0, 2) || "?";
  return (
    <div
      style={{
        width: 32,
        height: 32,
        borderRadius: 999,
        background: "var(--bsp-blue)",
        color: "var(--ink-000)",
        fontSize: 12,
        fontWeight: 700,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {initials}
    </div>
  );
}

export function TopBar() {
  const { user, signOut } = useAuth();
  const [open, setOpen] = useState(false);
  const display = user?.displayName || user?.email || "Loading…";

  return (
    <header className="bsp-topbar">
      <div className="bsp-topbar-title">BSP Tools Hub</div>

      <div style={{ position: "relative" }}>
        <button
          type="button"
          className="bsp-btn bsp-btn-ghost"
          onClick={() => setOpen((v) => !v)}
        >
          <Avatar name={display} />
          <span style={{ marginLeft: 8 }}>{display}</span>
          <ChevronDown size={14} style={{ marginLeft: 4 }} />
        </button>
        {open && (
          <div
            style={{
              position: "absolute",
              top: "100%",
              right: 0,
              marginTop: 8,
              minWidth: 200,
              background: "var(--bsp-surface)",
              border: "1px solid var(--bsp-border)",
              borderRadius: 8,
              boxShadow: "var(--bsp-shadow-pop)",
              padding: 8,
              zIndex: 100,
            }}
          >
            <button
              type="button"
              className="bsp-btn bsp-btn-ghost"
              style={{ width: "100%", justifyContent: "flex-start" }}
              onClick={() => void signOut()}
            >
              <LogOut size={14} style={{ marginRight: 8 }} />
              Sign out
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
